// Screenshot detection while the game board is active.
// iOS Capacitor: native posts window event "mmuScreenshotTaken".
// Web/dev: call notifyScreenshotTaken() or dispatch the same event.

const SCREENSHOT_EVENT = "mmuScreenshotTaken";

/**
 * Subscribe to screenshot notifications from native or tests.
 * @param {() => void} handler
 * @returns {() => void} unsubscribe
 */
export function subscribeToScreenshots(handler) {
    if (typeof window === "undefined" || typeof handler !== "function") {
        return () => {};
    }

    const onEvent = () => {
        try {
            handler();
        } catch (error) {
            console.error("Screenshot handler failed", error);
        }
    };

    window.addEventListener(SCREENSHOT_EVENT, onEvent);

    return () => {
        window.removeEventListener(SCREENSHOT_EVENT, onEvent);
    };
}

/** Fire a screenshot event (tests / admin simulate / native bridge). */
export function notifyScreenshotTaken() {
    if (typeof window === "undefined") {
        return;
    }

    window.dispatchEvent(new CustomEvent(SCREENSHOT_EVENT));
}

export const SCREENSHOT_TAKEN_EVENT = SCREENSHOT_EVENT;
